(() => {
  'use strict';
  const root = document.querySelector('[data-quilted-cuff]');
  if (!root) return;
  const q = selector => root.querySelector(selector);
  const all = selector => [...root.querySelectorAll(selector)];
  const cfg = JSON.parse(q('[data-quilted-cuff-config]').textContent);
  const form = q('#QuiltedCuffForm');
  const variantInput = q('[data-variant]');
  const base = (cfg.rootUrl || '/').replace(/\/?$/, '/');
  const cartUrl = cfg.cartUrl || base + 'cart';
  const checkoutUrl = base + 'checkout';
  const currency = cfg.currency || 'USD';
  const money = cents => new Intl.NumberFormat(cfg.locale || 'en-US', { style: 'currency', currency }).format(cents / 100);
  const route = (destination, code = '') => code ? base + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(destination) : destination;
  const storageKey = 'tl-quilted-cuff-pending:' + cfg.productId;
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const variants = (cfg.variants || []).filter(variant => Number.isSafeInteger(Number(variant.id)) && Number(variant.id) > 0 && Number.isSafeInteger(variant.price) && variant.price >= 0).map(variant => ({ ...variant, id: String(variant.id) }));
  const byId = id => variants.find(variant => variant.id === String(id));
  // Expected identity is Main-assigned; native price and stock remain authoritative.
  const mappingMatches = () => cfg.mappingVerified === true && cfg.nativeVariantCount === 1 && variants.length === 1 && typeof cfg.mapping?.expectedVariantId === 'string' && /^[1-9][0-9]*$/.test(cfg.mapping.expectedVariantId) && typeof cfg.mapping.expectedSku === 'string' && cfg.mapping.expectedSku.trim().length > 0 && variants[0].id === cfg.mapping.expectedVariantId && variants[0].sku === cfg.mapping.expectedSku;
  const capacity = variant => !variant?.available ? 0 : variant.inventoryManagement && variant.inventoryPolicy === 'deny' ? Math.max(0, Number(variant.inventoryQuantity) || 0) : Infinity;
  const variant = () => byId(variantInput.value);
  const quantity = () => Number(q('[name="quilted-cuff-offer"]:checked').value);
  const discountReady = selected => Boolean(mappingMatches() && cfg.duoEnabled === true && cfg.duoCodeConfirmed === true && currency === 'USD' && typeof cfg.duoCode === 'string' && cfg.duoCode.length > 0 && cfg.duoCode.length <= 64 && !/[^A-Za-z0-9_-]/.test(cfg.duoCode) && Number.isSafeInteger(cfg.duoDiscountPerItemCents) && cfg.duoDiscountPerItemCents > 0 && selected && cfg.duoDiscountPerItemCents < selected.price);
  const duoAllowed = selected => Boolean(mappingMatches() && cfg.duoEnabled === true && capacity(selected) >= 2);
  const prices = (selected, count) => {
    if (!selected) return null;
    const unit = selected.price - (count === 2 && discountReady(selected) ? cfg.duoDiscountPerItemCents : 0);
    return { unit, total: unit * count };
  };
  let busy = false;
  let navigating = false;
  let pending = null;
  let bagCode = '';
  let stockError = '';
  let bagOpener = null;
  let loadingOpener = null;
  let continuationTimer;

  function savePending(value) {
    pending = value;
    try {
      if (value) sessionStorage.setItem(storageKey, JSON.stringify(value));
      else sessionStorage.removeItem(storageKey);
    } catch { /* In-memory intent remains protected when browser storage is unavailable. */ }
  }
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    if (saved && saved.version === 1 && /^QC-[a-z0-9-]{8,100}$/i.test(saved.reference) && byId(saved.variantId) && [1, 2].includes(saved.quantity) && ['sending', 'saved'].includes(saved.status)) {
      pending = { ...saved, variantId: String(saved.variantId), code: saved.quantity === 2 && discountReady(byId(saved.variantId)) ? cfg.duoCode : '' };
    }
    if (discountReady(variants[0]) && sessionStorage.getItem(storageKey + ':offer') === cfg.duoCode) bagCode = cfg.duoCode;
  } catch { /* A malformed or unavailable storage entry must not block the native cart. */ }
  // Only an acknowledged response ends an intent. An uncertain POST is never replayed.
  if (pending?.status === 'saved') savePending(null);
  const explicitId = new URL(location.href).searchParams.get('variant');
  if (explicitId) variantInput.value = byId(explicitId)?.id || '';
  else variantInput.value = byId(cfg.selectedVariantId)?.id || variants.find(item => capacity(item) > 0)?.id || variants[0]?.id || '';
  q('[name="quilted-cuff-offer"][value="1"]').checked = true;
  if (pending) {
    variantInput.value = pending.variantId;
    q('[name="quilted-cuff-offer"][value="' + pending.quantity + '"]').checked = true;
    bagCode = pending.code || bagCode;
  }

  function selectionError(cart = null) {
    if (!mappingMatches()) return 'This style needs an availability check. Please contact us before ordering.';
    const selected = variant();
    if (!selected) return 'Please choose an available cuff.';
    if (!capacity(selected)) return 'This cuff is currently unavailable.';
    if (quantity() === 2 && cfg.duoEnabled !== true) return 'Please choose the single-cuff option.';
    const already = (cart?.items || []).filter(line => String(line.variant_id || line.id) === selected.id).reduce((sum, line) => sum + line.quantity, 0);
    if (already + quantity() > capacity(selected)) return 'There is not enough stock for this selection' + (already ? ' plus the cuffs already in your cart' : '') + '. Choose one cuff or review your cart.';
    return '';
  }
  function sync() {
    const selected = variant();
    const count = quantity();
    const current = prices(selected, count);
    stockError = selectionError();
    form.elements.quantity.value = String(count);
    for (const offerCount of [1, 2]) {
      const price = prices(selected, offerCount);
      q('[data-offer-unit="' + offerCount + '"]').replaceChildren(document.createTextNode(price ? money(price.unit) : '--'));
      const suffix = document.createElement('span');
      suffix.textContent = '/ cuff';
      q('[data-offer-unit="' + offerCount + '"]').append(suffix);
      q('[data-offer-total="' + offerCount + '"]').textContent = price ? money(price.total) + ' total' : 'Choose a cuff';
    }
    q('[data-unit-price]').textContent = current ? money(current.unit) : '--';
    q('[data-unit-caption]').textContent = count === 2 && discountReady(selected) ? 'per cuff with two-cuff offer' : 'per cuff';
    q('[data-duo-saving]').hidden = !discountReady(selected);
    q('[data-duo-saving]').textContent = discountReady(selected) ? 'Save ' + money(cfg.duoDiscountPerItemCents * 2) : '';
    q('[data-offer-note]').textContent = discountReady(selected) ? 'Two cuffs: ' + cfg.duoCode + ' takes ' + money(cfg.duoDiscountPerItemCents) + ' off each cuff at checkout. Minimum two. Other discounts do not combine.' : 'One unit is one cuff. Two units are two individual cuffs at the current unit price. Checkout confirms any applicable discounts.';
    q('[data-faq-offer]').textContent = discountReady(selected) ? 'Choose two cuffs to use ' + cfg.duoCode + '. It takes ' + money(cfg.duoDiscountPerItemCents) + ' off each eligible cuff using the current native cuff price. Checkout confirms eligibility, discounts and tax. Minimum two. Other discounts do not combine.' : 'Select one or two individual cuffs. The page uses the current cuff price for the total. Checkout confirms any applicable discounts and tax.';
    q('[data-selection-label]').textContent = count + (count === 1 ? ' cuff' : ' cuffs');
    q('[data-selection-contents]').textContent = count + (count === 1 ? ' cuff' : ' cuffs') + ' / gold color / 6 mm';
    q('[data-selection-total]').textContent = current ? money(current.total) : '--';
    q('[data-sticky-price]').textContent = current ? money(current.total) + ' / ' + count + (count === 1 ? ' cuff' : ' cuffs') : 'Choose a cuff';
    q('[data-stock-error]').textContent = stockError;
    q('[data-stock-error]').hidden = !stockError || (Boolean(pending) && mappingMatches());
    q('[data-add-label]').textContent = pending ? 'Check saved selection' : stockError ? 'Check availability' : 'Add ' + (count === 1 ? 'cuff' : 'two cuffs') + ' to cart';
    q('[data-buy-label]').textContent = pending ? 'Check cart & continue' : 'Buy now' + (current ? ' - ' + money(current.total) : '');
    q('[data-sticky-label]').textContent = stockError && !pending ? 'Check options' : 'Buy now';
    all('[data-add],[data-buy]').forEach(button => { button.disabled = busy || !mappingMatches() || (!pending && Boolean(stockError)); });
    q('[data-sticky-buy]').disabled = busy;
    all('[name="quilted-cuff-offer"]').forEach(input => { input.disabled = busy || !mappingMatches() || Boolean(pending) || (input.value === '2' && !duoAllowed(selected)); });
    // Keep the successful native ID field enabled so FormData never drops it.
    variantInput.disabled = !mappingMatches() || (variantInput.tagName === 'SELECT' && (busy || Boolean(pending)));
    form.setAttribute('aria-busy', String(busy));
  }
  function feedback(text, withCart = false, code = bagCode) {
    q('[data-feedback]').replaceChildren(document.createTextNode(text));
    if (withCart) {
      const link = document.createElement('a');
      link.href = route(cartUrl, code);
      link.textContent = ' View or edit your cart.';
      q('[data-feedback]').append(link);
    }
  }
  function loading(show) {
    const dialog = q('[data-loading]');
    if (show) {
      if (!dialog.open) { loadingOpener = document.activeElement; dialog.showModal(); }
    } else {
      clearTimeout(continuationTimer);
      q('[data-checkout-continue]').hidden = true;
      if (dialog.open) dialog.close();
      loadingOpener?.focus?.({ preventScroll: true });
    }
  }
  function setBusy(value, checkout = false) {
    busy = value;
    loading(value && checkout);
    sync();
  }
  async function request(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(url, { ...options, credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json', ...(options.headers || {}) } });
      const data = await response.json();
      if (!response.ok) {
        const error = new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'Your cart could not be updated. Please review it before trying again.');
        error.definiteRejection = response.status >= 400 && response.status < 500 && ![408, 429].includes(response.status);
        throw error;
      }
      return data;
    } finally { clearTimeout(timer); }
  }
  async function readCart() {
    const cart = await request(base + 'cart.js');
    if (!Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count) || cart.item_count < 0 || cart.items.some(line => !Number.isSafeInteger(line.quantity) || line.quantity < 1 || !Number.isSafeInteger(Number(line.variant_id || line.id)))) throw new Error('Your cart could not be confirmed. Open the native cart to review it; no extra cuffs were added.');
    return cart;
  }
  function recovery(cart) {
    const lines = (cart.items || []).filter(line => line.properties?.['_TENLOVE reference'] === pending.reference);
    if (!lines.length) return 'none';
    return lines.every(line => String(line.variant_id || line.id) === pending.variantId) && lines.reduce((sum, line) => sum + line.quantity, 0) === pending.quantity ? 'complete' : 'partial';
  }
  function renderBag(cart) {
    q('[data-bag-count]').textContent = cart.item_count;
    q('[data-bag-status]').textContent = cart.item_count ? cart.item_count + (cart.item_count === 1 ? ' item in your cart.' : ' items in your cart.') : 'Your cart is empty.';
    const list = q('[data-bag-lines]');
    list.replaceChildren();
    (cart.items || []).forEach(line => {
      const item = document.createElement('li');
      const title = document.createElement('b');
      const detail = document.createElement('span');
      const price = document.createElement('strong');
      title.textContent = line.product_title || line.title || 'Cart item';
      detail.textContent = [line.variant_title === 'Default Title' ? '' : line.variant_title, 'Quantity ' + line.quantity].filter(Boolean).join(' / ');
      price.textContent = Number.isFinite(line.final_line_price) ? money(line.final_line_price) : '';
      item.append(title, detail, price);
      list.append(item);
    });
    q('[data-bag-subtotal]').textContent = Number.isFinite(cart.total_price) ? money(cart.total_price) : 'Confirmed at checkout';
    q('[data-bag-offer]').textContent = bagCode ? bagCode + ' is carried to checkout for eligible cuffs. This subtotal may not include the offer yet. Native checkout confirms discounts, shipping and tax.' : 'Native checkout confirms discounts, shipping and any applicable tax.';
    q('[data-bag-checkout]').href = route(checkoutUrl, bagCode);
    q('[data-bag-checkout]').hidden = !cart.item_count;
    q('[data-native-bag]').href = route(cartUrl, bagCode);
  }
  function openBag() {
    bagOpener = document.activeElement;
    if (!q('[data-bag-dialog]').open) q('[data-bag-dialog]').showModal();
  }
  function closeBag() { q('[data-bag-dialog]').close(); bagOpener?.focus?.({ preventScroll: true }); }
  function navigateToCheckout() {
    const destination = route(checkoutUrl, bagCode);
    q('[data-loading-label]').textContent = 'Your selection is saved. Opening secure checkout...';
    q('[data-checkout-continue]').href = destination;
    continuationTimer = setTimeout(() => { q('[data-checkout-continue]').hidden = false; }, 10000);
    navigating = true;
    location.assign(destination);
  }
  async function add(checkout) {
    if (busy || !mappingMatches() || (!pending && stockError)) return;
    // showModal is synchronous: never expose a frozen PDP while native cart work runs.
    setBusy(true, checkout);
    feedback(checkout ? 'Adding your selection and opening checkout...' : 'Adding your selection to your cart...');
    let sending = false;
    let cart;
    try {
      cart = await readCart();
      if (!mappingMatches()) throw new Error('This style needs an availability check. Please contact us before ordering.');
      const state = pending ? recovery(cart) : 'none';
      if (state === 'partial') throw new Error('The saved selection in your cart needs a check. Review your cart; no extra cuffs have been added.');
      if (state === 'none') {
        // Missing now does not prove a timed-out earlier POST cannot commit later.
        if (pending) throw new Error('The earlier cart request has not been confirmed yet. Review your cart; we will not send it again and risk adding the cuff twice.');
        const error = selectionError(cart);
        if (error) throw new Error(error);
        savePending({ version: 1, reference: 'QC-' + (globalThis.crypto?.randomUUID?.() || Date.now().toString(36) + '-' + Math.random().toString(36).slice(2)), variantId: variant().id, quantity: quantity(), code: quantity() === 2 && discountReady(variant()) ? cfg.duoCode : '', status: 'sending' });
        sync();
        const body = new FormData(form);
        body.set('id', pending.variantId);
        body.set('quantity', String(pending.quantity));
        body.set('properties[Contents]', 'One open cuff per unit / gold color / width 6 mm / diameter 58-60 mm');
        body.set('properties[_TENLOVE reference]', pending.reference);
        body.delete('quilted-cuff-offer');
        body.delete('return_to');
        sending = true;
        const result = await request(base + 'cart/add.js', { method: 'POST', body });
        sending = false;
        const lines = Array.isArray(result.items) ? result.items : [result];
        if (recovery({ items: lines }) !== 'complete') throw new Error('Please review your cart to confirm the saved selection. We will check its reference before any retry.');
        q('[data-bag-count]').textContent = cart.item_count + pending.quantity;
      } else q('[data-bag-count]').textContent = cart.item_count;
      bagCode = pending.code || '';
      try { if (bagCode) sessionStorage.setItem(storageKey + ':offer', bagCode); else sessionStorage.removeItem(storageKey + ':offer'); } catch {}
      if (checkout) {
        savePending({ ...pending, status: 'saved' });
        // No coupon API or post-save cart read may hold a confirmed cart hostage.
        navigateToCheckout();
        return;
      }
      const count = pending.quantity;
      savePending(null);
      feedback('Added ' + count + (count === 1 ? ' cuff' : ' cuffs') + ' to your cart.', true);
      try { renderBag(await readCart()); openBag(); }
      catch { feedback('Your cuffs were saved. Open your cart to review them and continue.', true); }
    } catch (error) {
      navigating = false;
      if (sending && error.definiteRejection) {
        try { if (recovery(await readCart()) === 'none') savePending(null); } catch {}
      }
      feedback(error.name === 'AbortError' ? 'That request took longer than expected. Review your cart; we will check for your saved selection without adding it twice.' : error.message || 'Please review your cart before trying again.', true, pending?.code || bagCode);
    } finally { if (!navigating) setBusy(false); }
  }
  form.addEventListener('submit', event => {
    event.preventDefault();
    add(Boolean(event.submitter?.hasAttribute('data-buy')));
  });
  all('[name="quilted-cuff-offer"]').forEach(input => input.addEventListener('change', () => { if (!busy && !pending) sync(); }));
  variantInput.addEventListener('change', () => {
    if (busy || pending) return;
    if (!duoAllowed(variant())) q('[name="quilted-cuff-offer"][value="1"]').checked = true;
    const url = new URL(location.href);
    if (variant()) { url.searchParams.set('variant', variant().id); history.replaceState(history.state, '', url); }
    sync();
  });
  q('[data-sticky-buy]').addEventListener('click', () => {
    if (stockError && !pending) {
      q('#QuiltedCuffPurchase').scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      if (variantInput.tagName === 'SELECT') variantInput.focus({ preventScroll: true });
    } else add(true);
  });
  q('[data-open-bag]').addEventListener('click', async event => {
    event.preventDefault();
    if (busy) return;
    openBag();
    q('[data-bag-status]').textContent = 'Loading your cart...';
    q('[data-bag-checkout]').hidden = true;
    q('[data-bag-lines]').replaceChildren();
    q('[data-bag-subtotal]').textContent = '';
    q('[data-bag-offer]').textContent = '';
    try { renderBag(await readCart()); }
    catch { q('[data-bag-status]').textContent = 'Use View or edit your cart below to continue in the native cart.'; }
  });
  q('[data-close-bag]').addEventListener('click', closeBag);
  q('[data-continue]').addEventListener('click', closeBag);
  q('[data-bag-dialog]').addEventListener('click', event => { if (event.target === q('[data-bag-dialog]')) closeBag(); });
  q('[data-bag-checkout]').addEventListener('click', event => { event.preventDefault(); closeBag(); setBusy(true, true); navigateToCheckout(); });
  q('[data-loading]').addEventListener('cancel', event => { if (busy) event.preventDefault(); });

  const photo = q('[data-main-photo]');
  const thumbs = all('[data-thumb]');
  const lightbox = q('[data-lightbox]');
  let photoIndex = 0;
  function selectPhoto(index) {
    photoIndex = (index + thumbs.length) % thumbs.length;
    const button = thumbs[photoIndex];
    photo.src = button.dataset.full;
    photo.srcset = button.dataset.small + ' 600w, ' + button.dataset.full + ' 1200w';
    photo.alt = button.dataset.alt;
    q('[data-photo-index]').textContent = String(photoIndex + 1).padStart(2, '0') + ' / ' + String(thumbs.length).padStart(2, '0');
    thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
    if (lightbox.open) { lightbox.querySelector('img').src = button.dataset.full; lightbox.querySelector('img').alt = button.dataset.alt; }
  }
  thumbs.forEach((button, index) => button.addEventListener('click', () => selectPhoto(index)));
  q('[data-enlarge]').addEventListener('click', () => { lightbox.querySelector('img').src = thumbs[photoIndex].dataset.full; lightbox.querySelector('img').alt = photo.alt; lightbox.showModal(); });
  q('[data-close-photo]').addEventListener('click', () => lightbox.close());
  lightbox.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); });
  lightbox.addEventListener('close', () => q('[data-enlarge]').focus({ preventScroll: true }));
  function inspectSource() {
    selectPhoto(thumbs.findIndex(button => button.hasAttribute('data-source')));
    q('[data-enlarge]').scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
    thumbs[photoIndex].focus({ preventScroll: true });
  }
  q('[data-inspect-source]').addEventListener('click', inspectSource);
  q('[data-finish-photo]').addEventListener('click', inspectSource);
  q('.qc-thumbs').addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    selectPhoto(event.key === 'Home' ? 0 : event.key === 'End' ? thumbs.length - 1 : photoIndex + (event.key === 'ArrowRight' ? 1 : -1));
    thumbs[photoIndex].focus();
  });
  lightbox.addEventListener('keydown', event => { if (['ArrowLeft', 'ArrowRight'].includes(event.key)) { event.preventDefault(); selectPhoto(photoIndex + (event.key === 'ArrowRight' ? 1 : -1)); } });
  if ('IntersectionObserver' in window) new IntersectionObserver(([entry]) => { q('[data-sticky]').hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0; }).observe(form);
  window.addEventListener('pageshow', () => {
    navigating = false;
    if (pending?.status === 'saved') savePending(null);
    setBusy(false);
  });
  if (pending) feedback('An earlier selection needs a reference check before another cuff is added.', true, pending.code);
  sync();
})();
